var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":""}},[[_c('i',{class:_vm.iconClass,style:(("color:" + _vm.iconColor)),attrs:{"slot":"activator","pr-2":""},slot:"activator"})],_c('span',{domProps:{"innerHTML":_vm._s(_vm.text)}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }